import PageCommon from "../PageCommon.js";

export default class Appear extends PageCommon {
	constructor(item) {
		super();

		this.objects = [];
		this.item = item ?? ".js-move-elem";
		this.duration = 1;
		this.delay = 0.2;
		this.opacity = 0.3;
		this.inAnimations = [];
	}
	init() {
		super.init();
		this.setupElements();

		this.scrolls = 0;

		let refHeight = 0;
		if (document.querySelector(".cover-hp")) {
			refHeight = document.querySelector(".cover-hp").offsetHeight;
		}

		if (window.innerWidth > this.maxWidthMobile) {
			window.addEventListener("scroll", (event) => {
				this.animateElements();
				if (this.scrolls === 0) {
					this.scrolls++;
				} else if (this.scrolls === 1) {
					this.scrolls++;
					if (document.querySelector("div.drag-btn img")) {
						document.querySelector("div.drag-btn img").dispatchEvent(new Event("reset"));
					}
				} else if (window.scrollY > refHeight && this.scrolls === 2) {
					// console.log("FIRE");
					this.scrolls++;
					setTimeout(() => {
						this.resetCover();
					}, 1000);
				}
			});
			this.animateElements();
			if (refHeight > 0 && window.scrollY > refHeight) {
				Array.from(document.querySelectorAll(".moveout")).map((item) => item.classList.remove("moveout"));
				document.querySelector(".drag-btn").style.cursor = "default";
				if (window.scrollY < refHeight * 2) {
					this.animatePageChange();
				}
			}
		}
	}

	shakeDrag() {
		const drag = document.querySelector("div.drag-btn img");
		TweenMax.to(drag, 0.5, { y: -10, repeat: -1, yoyo: true });
	}

	resetAnimations() {
		this.inAnimations.map((animation) => {
			animation.play();
		});
		Array.from(document.querySelectorAll(".js-move-elem")).map((item) => {
			item.classList.add("moved");
		});
	}

	setupElements() {
		Array.from(document.querySelectorAll(this.item)).map((item) => {
			if (window.innerWidth <= this.maxWidthMobile) {
				item.classList.remove("js-move-elem");
			} else {
				const { x: offsetLeft, y: offsetTop } = this.getAbsPosition(item);
				item.dataset.offsettop = offsetTop;
				this.inAnimation(item);

				const animation = TweenMax.getTweensOf(item)[0];
				if (animation) {
					animation.pause();
					this.inAnimations.push(animation);
				}
			}
		});
	}

	inAnimation(item) {
		if (item.dataset.movex && item.dataset.movey) {
			TweenMax.from(item, +(item.dataset.moveduration ?? this.duration), {
				x: item.dataset.movex,
				y: item.dataset.movey,
				opacity: this.opacity,
				delay: item.dataset.movedelay !== undefined ? item.dataset.movedelay : this.delay,
			});
		} else if (item.dataset.movex) {
			TweenMax.from(item, +(item.dataset.moveduration ?? this.duration), {
				x: item.dataset.movex,
				opacity: this.opacity,
				delay: item.dataset.movedelay !== undefined ? item.dataset.movedelay : this.delay,
			});
		} else if (item.dataset.movey) {
			TweenMax.from(item, +(item.dataset.moveduration ?? this.duration), {
				y: item.dataset.movey,
				opacity: this.opacity,
				delay: item.dataset.movedelay !== undefined ? item.dataset.movedelay : this.delay,
			});
		}
	}

	outAnimation(item) {
		if (item.dataset.moveoutx && item.dataset.moveouty) {
			TweenMax.to(item, +(item.dataset.moveduration ?? this.duration), {
				x: item.dataset.moveoutx,
				y: item.dataset.moveouty,
				opacity: 0,
			});
		} else if (item.dataset.moveoutx) {
			TweenMax.to(item, +(item.dataset.moveduration ?? this.duration), { x: item.dataset.moveoutx, opacity: 0 });
		} else if (item.dataset.moveouty) {
			TweenMax.to(item, +(item.dataset.moveduration ?? this.duration), { y: item.dataset.moveouty, opacity: 0 });
		}
	}

	resetElements() {
		// console.log("RESET ELEMENTS");
		this.scrolls = 2;
		if (window.scrollY <= 100) {
			$("html, body").animate(
				{
					scrollTop: $(".viaggio-section").offset().top,
				},
				1000
			);
		}
		this.animatePageChange();
		const elements = Array.from(document.querySelectorAll(this.item + ".moveout"));
		elements.map((item, index) => {
			this.outAnimation(item);
		});
		document.querySelector(".drag-btn").style.cursor = "default";
	}

	resetCover() {
		// console.log("RESET COVER");
		const elements = Array.from(document.querySelectorAll(this.item + ".moveout"));
		elements.map((item, index) => {
			item.style.transform = "";
		});
		const animation = TweenMax.getTweensOf(document.querySelector(".drag-elem"))[0];
		if (animation) {
			animation.kill();
		}
	}

	animatePageChange() {
		const elements = Array.from(document.querySelectorAll(".js-page-change"));
		elements.map((pageChange, index) => {
			pageChange.classList.add("moved");
			const animation = TweenMax.getTweensOf(pageChange)[0];
			if (animation) {
				animation.play();
			}
		});
	}

	animateElements() {
		Array.from(document.querySelectorAll(this.item + ":not(.moved):not(.js-page-change)")).map((item) => {
			if (item.dataset.offsettop < window.scrollY + window.outerHeight / 1.2) {
				item.classList.add("moved");
				const animation = TweenMax.getTweensOf(item)[0];
				if (animation) {
					if (item.classList.contains("drag-elem")) {
						animation.eventCallback("onComplete", this.shakeDrag);
					}
					animation.play();
				}
			}
		});
	}

	getAbsPosition(element) {
		var rect = element.getBoundingClientRect();
		return { x: rect.left, y: rect.top };
	}
}
